<script>
// import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import axios from "axios";
// import axios from "axios";
// import Swal from "sweetalert2";

export default {
  page: {
    title: "Report Nilai Jabatan Detail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  // components: { PageHeader },
  data() {
    const menu = "Report Nilai Jabatan Detail";
    return {
      title: menu,
      dataParam: null,
      header: null,
      chartType: "radar",
      kompetensi: [],
      $categories: [],
      series: [],
      chartOptions: {},
    };
  },
  methods: {
    async getData() {
      await axios({
        method: "get",
        url: `${process.env.VUE_APP_BACKEND_URL_VERSION}report-nilai-jabatan-detail`,
        params: this.dataParam,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      }).then((response) => {
        console.log({ data: response.data.data });
        const responseData = response.data.data;
        this.categories = responseData.categories;
        this.header = responseData.header;
        this.kompetensi = responseData.kompetensi;
        this.series = responseData.series;
        this.chartType = this.kompetensi.length > 1 ? "radar" : "radialBar";
        this.setDataChart();
      });
    },
    setDataChart() {
      if (this.chartType == "radar") {
        this.chartOptions = {
          chart: {
            type: this.chartType,
            dropShadow: {
              enabled: true,
              blur: 1,
              left: 1,
              top: 1,
            },
          },
          title: {
            text: "",
          },
          stroke: {
            width: 2,
          },
          fill: {
            opacity: 0,
          },
          markers: {
            size: 0,
          },
          yaxis: {
            max: 100,
            min: 0,
          },
          xaxis: {
            categories: this.categories,
          },
        };
      } else {
        const val = this.kompetensi[0].persentase;
        this.series = [val];
        this.chartOptions = {
          chart: {
            // height: 350,
            type: "radialBar",
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: `80%`,
              },
              dataLabels: {
                formatter: function (val) {
                  return val;
                },
                textAnchor: "middle",
                distributed: true,
                name: {
                  show: false,
                },
                value: {
                  fontSize: "30px",
                  color: "#2c3e50",
                  fontWeight: "bold",
                  formatter: function (val) {
                    return val;
                  },
                },
              },
            },
          },
          labels: [this.categories[0]],
        };
      }
    },
  },
  mounted() {
    const raw = this.$route.query.data;
    if (raw) {
      this.dataParam = JSON.parse(raw);
    }
    console.log({ raw, dataParam: this.dataParam });
    this.getData();
  },
};
</script>
<template>
  <div>
    <div class="row">
      <div class="col-6">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div class="card-title">Report Nilai Jabatan</div>
              </div>
              <table class="mt-2">
                <tr class="mb-2">
                  <td>
                    <label for="">Jenis Asesmen</label>
                  </td>
                  <td>
                    <label for="">&nbsp;:&nbsp;</label>
                  </td>
                  <td>
                    <label for="">{{ header?.pelaksanaan ?? "-" }}</label>
                  </td>
                </tr>
                <tr class="mb-2">
                  <td>
                    <label for="">Keterangan Asesmen</label>
                  </td>
                  <td>
                    <label for="">&nbsp;:&nbsp;</label>
                  </td>
                  <td>
                    <label for="">{{ header?.keterangan ?? "-" }}</label>
                  </td>
                </tr>
                <tr class="mb-2">
                  <td>
                    <label for="">NIP</label>
                  </td>
                  <td>
                    <label for="">&nbsp;:&nbsp;</label>
                  </td>
                  <td>
                    <label for="">{{ header?.nip ?? "-" }}</label>
                  </td>
                </tr>
                <tr class="mb-2">
                  <td>
                    <label for="">Nama</label>
                  </td>
                  <td>
                    <label for="">&nbsp;:&nbsp;</label>
                  </td>
                  <td>
                    <label for="">{{ header?.nama ?? "-" }}</label>
                  </td>
                </tr>
                <tr class="mb-2">
                  <td>
                    <label for="">Unit asal</label>
                  </td>
                  <td>
                    <label for="">&nbsp;:&nbsp;</label>
                  </td>
                  <td>
                    <label for="">{{ header?.nama_unit ?? "-" }}</label>
                  </td>
                </tr>
                <tr class="mb-2">
                  <td>
                    <label for="">Jabatan Asesmen</label>
                  </td>
                  <td>
                    <label for="">&nbsp;:&nbsp;</label>
                  </td>
                  <td>
                    <label for="">{{ header?.jabatan_nama ?? "-" }}</label>
                  </td>
                </tr>
                <tr class="mb-2">
                  <td>
                    <label for="">Tanggal</label>
                  </td>
                  <td>
                    <label for="">&nbsp;:&nbsp;</label>
                  </td>
                  <td>
                    <label for="">{{ header?.waktu ?? "-" }} </label>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <table class="table table-bordered table-condensed table-hover">
                <thead class="bg-dark text-center text-white align-middle">
                  <tr>
                    <th>Kompetensi</th>
                    <th>Skor</th>
                    <th>Tipe Kompetensi</th>
                    <th>Level Proficiency</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, key) in kompetensi" :key="key">
                    <td>{{ row.nama_kompetensi }}</td>
                    <td class="text-center">{{ row.persentase }}</td>
                    <td class="text-center">{{ row.tipe_kompetensi }}</td>
                    <td class="text-center">{{ row.level }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <div id="chart">
              <apexchart
                v-if="chartType === 'radar'"
                type="radar"
                :options="chartOptions"
                :series="series"
              ></apexchart>
              <apexchart
                v-else
                type="radialBar"
                height="350"
                :options="chartOptions"
                :series="series"
              ></apexchart>
              <div
                class="text-center"
                style="margin-top: -20px"
                v-if="chartType == 'radialBar' && kompetensi.length > 0"
              >
                <div style="font-weight: bold">
                  {{ kompetensi[0].nama_kompetensi }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
